export const FLAG_GETTING_ADDRESSES = 'FLAG_GETTING_ADDRESSES';
export const GET_ADDRESSES = 'GET_ADDRESSES';
export const CLEAR_ADDRESSES = 'CLEAR_ADDRESSES';
export const FLAG_ADDRESS_ACTIVITY = 'FLAG_ADDRESS_ACTIVITY';
export const GET_ADDRESS = 'GET_ADDRESS';
export const CLEAR_ADDRESS = 'CLEAR_ADDRESS';
